import React, { useRef } from "react";
import { Typography, Box, TextField, Button, Grid, Chip } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Signature from "../../../../common/signature/signature";

// Define validation schema
const validationSchema = Yup.object().shape({
  youngPersonName: Yup.string().required("Required"),
  homeName: Yup.string().required("Required"),
  parentalResponsibility: Yup.string().required("Required"),
  relationshipToYoungPerson: Yup.string().required("Required"),
});

// Initial form values
const initialValues = {
  youngPersonName: "",
  homeName: "",
  parentalResponsibility: "",
  relationshipToYoungPerson: "",
};

const MedicalConsentAdmission = () => {
  const signatureRef = useRef(null);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const signatureData = signatureRef.current.getSignatureData();
        if (!signatureData) {
          alert("Please provide a signature");
          return;
        }

        const formData = { ...values, signature: signatureData };

        console.log("Form data submitted:", formData);
      }}
    >
      {({ handleSubmit, handleChange, values, errors, touched }) => (
        <Form onSubmit={handleSubmit} className='admission-form'>
          {/* Header Section */}
          <Box>
            <Chip label='Admission' />
            <Typography sx={{ fontSize: "24px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
              Consent For The Administration Of First Aid & <br />
              Medication
            </Typography>
            <Typography sx={{ fontSize: "14px" }} mt={1} mb={2}>
              Form to report, document, and review incidents involving young persons for accountability and safety
              measures.
            </Typography>
          </Box>

          {/* Form Fields */}
          <Grid container spacing={2} mt={3}>
            <Grid item xs={12} sm={5}>
              <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                Young Person Name
              </Typography>
              <TextField
                fullWidth
                placeholder='Enter young person name'
                name='youngPersonName'
                variant='outlined'
                value={values.youngPersonName}
                onChange={handleChange}
                error={touched.youngPersonName && Boolean(errors.youngPersonName)}
                helperText={touched.youngPersonName && errors.youngPersonName}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={5}>
              <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                Home Name
              </Typography>
              <TextField
                fullWidth
                placeholder='Enter Home Name'
                name='homeName'
                variant='outlined'
                value={values.homeName}
                onChange={handleChange}
                error={touched.homeName && Boolean(errors.homeName)}
                helperText={touched.homeName && errors.homeName}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={5}>
              <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                Person with Parental Responsibility
              </Typography>
              <TextField
                fullWidth
                placeholder='Enter Person Parental Responsibility'
                name='parentalResponsibility'
                variant='outlined'
                value={values.parentalResponsibility}
                onChange={handleChange}
                error={touched.parentalResponsibility && Boolean(errors.parentalResponsibility)}
                helperText={touched.parentalResponsibility && errors.parentalResponsibility}
              />
            </Grid>
            <Grid item xs={12} sm={5}>
              <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                Relationship to Young Person
              </Typography>
              <TextField
                fullWidth
                placeholder='Enter Relationship to Young Person'
                name='relationshipToYoungPerson'
                variant='outlined'
                value={values.relationshipToYoungPerson}
                onChange={handleChange}
                error={touched.relationshipToYoungPerson && Boolean(errors.relationshipToYoungPerson)}
                helperText={touched.relationshipToYoungPerson && errors.relationshipToYoungPerson}
              />
            </Grid>
          </Grid>

          {/* Agreement Text */}
          <Box mt={4} mb={2}>
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              I <span style={{ color: "#1E88E5" }}>Sudewa</span> agree that
              <span style={{ color: "#1E88E5" }}> Mr Venupushparaja </span>
              for whom I have parental responsibility, can receive appropriate first aid as required whilst in the care
              of Active Care Company Limited.
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "black" }} mt={2}>
              I further agree that <span style={{ color: "#1E88E5" }}>Kuppa</span> may receive such medication as is
              prescribed by their GP or is as agreed by their GP to be non-prescribed medication. This includes
              paracetamol and cough medicine.
            </Typography>
          </Box>

          {/* Signature Section */}
          <Box className='signature-box' mt={4}>
            <Signature ref={signatureRef} />
            <Typography align='right'>
              <Grid container justifyContent='flex-end'>
                <Grid item>
                  <Typography sx={{ fontSize: "14px", color: "#FFB700" }}>venorox</Typography>
                </Grid>
                <Grid item>
                  <Grid><Typography sx={{ fontSize: "14px" }}>/ Signature</Typography></Grid>
                </Grid>
              </Grid>
              <Typography sx={{ fontSize: "13px" }} align='right'>
                2024/03/12
              </Typography>
              <Grid container justifyContent='flex-end' mt={1}>
                <Button variant='outlined' onClick={() => signatureRef.current?.clearSignature()}>
                  Clear
                </Button>
              </Grid>
            </Typography>
          </Box>

          {/* Submit Button */}
          <Grid container justifyContent='flex-end' mt={3}>
            <Button type='submit' variant='contained' color='primary'>
              Submit
            </Button>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default MedicalConsentAdmission;
